"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const exceljs_1 = __importDefault(require("exceljs"));
const file_saver_1 = require("file-saver");
const HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
const FileUpload_1 = __importDefault(require("@mui/icons-material/FileUpload"));
const FileDownload_1 = __importDefault(require("@mui/icons-material/FileDownload"));
const shared_1 = require("../shared");
const styles_1 = require("@mui/material/styles");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CustomnButton = (0, styles_1.styled)(Button_1.default)(({ theme }) => ({
    color: '#FFFF',
    backgroundColor: '#0146C6',
    borderRadius: '1vmax',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: '1vmax',
    justifyContent: 'center',
    padding: '0.4vmax',
    width: '30%',
    '&:hover': {
        backgroundColor: '#0146C6',
    },
}));
const StrapiUpload = ({ open, setOpen, refresh }) => {
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridTemplateRows: 'repeat(11, 1fr)',
        width: '100%',
        height: '68vh',
        border: '2px dashed #ccc',
        position: 'relative',
        margin: '0 auto',
        transition: 'background-color 0.3s ease',
        cursor: 'pointer',
    };
    const cellStyle = {
        border: '1px solid skyblue',
    };
    const messageStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '2vh',
        color: '#333',
        textAlign: 'center',
    };
    const imageStyle = {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '15vh',
        height: '15vh',
        color: 'blue',
        textAlign: 'center',
    };
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45vh',
        height: '30vh',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const compBoxStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45vh',
        height: '15vh',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const statusStyle = {
        width: '44vh',
        height: '25vh',
        overflowY: 'auto',
    };
    const compStyle = {
        width: '44vh',
        height: '15vh',
        overflowY: 'auto',
    };
    const md = require('markdown-it')({
        html: true,
        linkify: true,
        typographer: true,
    });
    const fileInputRef = (0, react_1.useRef)(null);
    const [excelData, setExcelData] = (0, react_1.useState)([]);
    const [jsonData, setJsonData] = (0, react_1.useState)([]);
    const [downlaodData, setDownlaodData] = (0, react_1.useState)([]);
    const [uploadedFile, setUploadedFile] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)('');
    const [openModal, setOpenModal] = react_1.default.useState(false);
    const [initDataLoad, setInitDataLoad] = (0, react_1.useState)(true);
    const [difficultyList, setDfficultyList] = (0, react_1.useState)([]);
    const [testTypeList, setTestTypeList] = (0, react_1.useState)([]);
    const [diagnosticList, setDiagnosticList] = (0, react_1.useState)([]);
    const [typeList, setTypeList] = (0, react_1.useState)([]);
    const [subTypeList, setSubTypeList] = (0, react_1.useState)([]);
    const [areaList, setAreaList] = (0, react_1.useState)([]);
    const [kahnAcademyTypeList, setKahnAcademyTypeList] = (0, react_1.useState)([]);
    const [status, setStatus] = (0, react_1.useState)([]);
    const [isProceesing, setIsProceesing] = (0, react_1.useState)(false);
    const initData = async () => {
        if (initDataLoad) {
            setTestTypeList(await (0, shared_1.getStrapiData)(`test-types?&sort=displayOrder:asc`));
            setDiagnosticList(await (0, shared_1.getStrapiData)(`diagnostics?&populate=*&pagination[pageSize]=100`));
            setTypeList(await (0, shared_1.getStrapiData)(`question-types?&sort=displayOrder:asc`));
            setSubTypeList(await (0, shared_1.getStrapiData)(`questions-subtypes?&sort=displayOrder:asc`));
            setAreaList(await (0, shared_1.getStrapiData)(`areas?&sort=displayOrder:asc`));
            setKahnAcademyTypeList(await (0, shared_1.getStrapiData)(`kahn-academy-types?&sort=displayOrder:asc`));
            setDfficultyList(await (0, shared_1.getStrapiData)(`difficultys?&sort=displayOrder:asc`));
            setInitDataLoad(false);
        }
    };
    (0, react_1.useEffect)(() => {
        initData();
    }, []);
    const handleExcelData = async (file) => {
        if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
            setUploadedFile(file);
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const buffer = e.target.result;
                    const workbook = new exceljs_1.default.Workbook();
                    await workbook.xlsx.load(buffer);
                    const worksheet = workbook.worksheets[0]; // First sheet
                    const exceldatatoLoad = [];
                    worksheet.eachRow((row, rowNumber) => {
                        const rowValues = Array.isArray(row.values) ? row.values.slice(1) : [];
                        exceldatatoLoad.push(rowValues.map((v) => (v === null || v === undefined ? '(blank)' : v)));
                    });
                    const jsonData = [];
                    const headers = exceldatatoLoad[0];
                    for (let i = 1; i < exceldatatoLoad.length; i++) {
                        const obj = {};
                        headers.forEach((key, index) => {
                            obj[key] = exceldatatoLoad[i][index];
                        });
                        jsonData.push(obj);
                    }
                    setExcelData(exceldatatoLoad);
                    setJsonData(jsonData);
                    setError('');
                }
                catch (err) {
                    console.error(err);
                    setError('Error parsing Excel file');
                }
            };
            reader.onerror = () => {
                setError('Error reading file');
            };
            reader.readAsArrayBuffer(file);
        }
        else {
            if (file) {
                setError('Please upload a valid Excel file (.xlsx or .xls)');
            }
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        handleExcelData(file);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleFileSelect = (e) => {
        setExcelData([]);
        setError('');
        setJsonData([]);
        setStatus([]);
        setOpenModal(false);
        setIsProceesing(false);
        const file = e.target.files[0];
        handleExcelData(file);
        fileInputRef.current.value = null;
    };
    const handleClearFile = () => {
        setExcelData([]);
        fileInputRef.current.value = '';
    };
    const handleModalOpen = () => {
        setOpenModal(true);
        setExcelData([]);
        setJsonData([]);
        setError('');
    };
    const handleModalClose = () => {
        setExcelData([]);
        setError('');
        setJsonData([]);
        setStatus([]);
        setOpenModal(false);
        setOpen(false);
        setIsProceesing(false);
        refresh();
    };
    const handleClose = () => {
        setExcelData([]);
        setError('');
        setJsonData([]);
        setStatus([]);
        setOpen(false);
        setIsProceesing(false);
        setOpenModal(false);
        if (openModal) {
            refresh();
        }
    };
    const handleUploadClick = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };
    //Below code is customizing uploaded excel data
    const getId = (value, listType) => {
        if (value != '' && value != undefined) {
            let list;
            switch (listType) {
                case 'difficulty':
                    list = difficultyList;
                    break;
                case 'testType':
                    list = testTypeList;
                    break;
                case 'type':
                    list = typeList;
                    break;
                case 'subType':
                    list = subTypeList;
                    break;
                case 'diagnostic':
                    list = diagnosticList;
                    break;
                case 'area':
                    list = areaList;
                    break;
                case 'kahnAcademyType':
                    list = kahnAcademyTypeList;
                    break;
                default:
                    list = [];
            }
            const test = list.find((x) => { var _a, _b; return `${((_a = x.attributes) === null || _a === void 0 ? void 0 : _a.Name) || ((_b = x.attributes) === null || _b === void 0 ? void 0 : _b.name)}` === `${value.trim()}`; });
            return (test === null || test === void 0 ? void 0 : test.id) || '';
        }
    };
    const handleAnswerChoice = (answerCount, excelJsondata) => {
        if (answerCount > 0) {
            let answerArray = [];
            for (let i = 0; i < answerCount; i++) {
                let num = i + 1;
                if (excelJsondata['AnswerChoices_' + num + '_IsCorrect'] != undefined) {
                    let answerObj = {
                        IsCorrect: excelJsondata['AnswerChoices_' + num + '_IsCorrect'],
                        Order: excelJsondata['AnswerChoices_' + num + '_Order'],
                        Description: excelJsondata['AnswerChoices_' + num + '_Description'].toString(),
                        optionType: excelJsondata['AnswerChoices_' + num + '_OptionType'],
                    };
                    answerArray.push(answerObj);
                }
            }
            return answerArray;
        }
        else {
            return [];
        }
    };
    const handleCorrectAnswers = (correctAnswer, excelJsondata) => {
        if (correctAnswer > 0) {
            let answerArray = [];
            let str = 'CorrectAnswers_' + Number(0 + 1) + '_Answer';
            for (let i = 0; i < correctAnswer; i++) {
                let num = i + 1;
                if (excelJsondata['CorrectAnswers_' + num + '_Answer'] != undefined) {
                    let answerObj = {
                        Answer: excelJsondata['CorrectAnswers_' + num + '_Answer'].toString(),
                    };
                    answerArray.push(answerObj);
                }
            }
            return answerArray;
        }
        else {
            return [{}];
        }
    };
    const saveAsExcelFile = async () => {
        var _a;
        const workbook = new exceljs_1.default.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
        if (downlaodData.length > 0) {
            const columns = Object.keys(downlaodData[0]).map((key) => ({
                header: key,
                key: key,
                width: 20,
            }));
            worksheet.columns = columns;
            downlaodData.forEach((row) => {
                worksheet.addRow(row);
            });
        }
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const fName = (((_a = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name) === null || _a === void 0 ? void 0 : _a.split('.')[0]) || 'export') + '_updated.xlsx';
        (0, file_saver_1.saveAs)(blob, fName);
    };
    const handleSaveClick = async () => {
        setIsProceesing(true);
        let fData = [];
        for (const data of jsonData) {
            let res = await handleData(data);
            let result = '';
            if (res.split('||')[0] !== 'success') {
                result = 'QuestionId ' + data['QuestionId'] + res.toString();
                setStatus((oldArray) => [...oldArray, result]);
                let failedData = data;
                failedData['Status'] = 'Failed - ' + result;
                fData.push(failedData);
            }
            else {
                let successData = data;
                successData['StrapiId'] = parseInt(res.split('||')[1]);
                successData['Status'] = 'Success';
                fData.push(successData);
            }
        }
        setDownlaodData(fData);
        setIsProceesing(false);
        handleModalOpen();
    };
    const insertQuestion = async (isActive, questionType, difficulty, question, explanation, answerChoices, minimumTime, maximumTime, questionDifficultyValue, questionSubTypeValue, totalQuestionValue, correctAnswers, testType, diagnostic, type, subType, area, kahnAcademyType, isPublic, displayOrder, description, solvableUsingDesmos, strapiId) => {
        let questionCollection = {
            IsActive: isActive,
            QuestionType: questionType,
            Difficulty: difficulty,
            Question: question,
            Explanation: explanation,
            //"AnswerChoices": answerChoices,
            MinimumTime: minimumTime,
            MaximumTime: maximumTime,
            questionDifficultyValue: questionDifficultyValue,
            questionSubTypeValue: questionSubTypeValue,
            totalQuestionValue: totalQuestionValue,
            CorrectAnswers: correctAnswers,
            Description: description,
        };
        if (answerChoices.length > 0) {
            questionCollection['AnswerChoices'] = answerChoices;
        }
        let data = {
            Question: questionCollection,
            TestType: testType,
            Diagnostic: diagnostic,
            Type: type,
            SubType: subType,
            Area: area,
            KahnAcademyType: kahnAcademyType,
            IsPublic: isPublic,
            displayOrder: displayOrder,
            solvableUsingDesmos: solvableUsingDesmos,
        };
        let response;
        if (isNaN(strapiId)) {
            response = await (0, shared_1.strapiCustomization)('questions', data, 'insert');
        }
        else {
            data['id'] = strapiId;
            response = await (0, shared_1.strapiCustomization)('questions', data, 'update');
        }
        return response;
    };
    const handleData = (excelJsondata) => {
        let isActive, questionType, difficulty, question, explanation, answerChoices, minimumTime, maximumTime, questionDifficultyValue, questionSubTypeValue, totalQuestionValue, correctAnswers, testType, diagnostic, type, subType, area, kahnAcademyType, isPublic, displayOrder, description, solvableUsingDesmos, strapiId;
        questionType = excelJsondata['QuestionType'];
        difficulty = getId(excelJsondata['Difficulty'], 'difficulty');
        question = excelJsondata['Question'];
        explanation = excelJsondata['Explanation'];
        minimumTime = excelJsondata['MinimumTime'];
        maximumTime = excelJsondata['MaximumTime'];
        questionDifficultyValue = excelJsondata['QuestionDifficultyValue'];
        questionSubTypeValue = excelJsondata['QuestionSubTypeValue'];
        totalQuestionValue = excelJsondata['TotalQuestionValue'];
        testType = getId(excelJsondata['TestType'], 'testType');
        diagnostic = getId(excelJsondata['Diagnostic'], 'diagnostic');
        type = getId(excelJsondata['Type'], 'type');
        subType = getId(excelJsondata['SubType'], 'subType');
        area = getId(excelJsondata['Area'], 'area');
        kahnAcademyType = getId(excelJsondata['KahnAcademyType'], 'kahnAcademyType');
        isPublic = excelJsondata['IsPublic'];
        displayOrder = excelJsondata['DisplayOrder'];
        answerChoices = handleAnswerChoice(excelJsondata['AnswerChoices'], excelJsondata);
        correctAnswers = handleCorrectAnswers(excelJsondata['CorrectAnswers'], excelJsondata);
        isActive = excelJsondata['IsActive'];
        description = excelJsondata['Description'];
        solvableUsingDesmos = excelJsondata['solvableUsingDesmos'];
        strapiId = parseInt(excelJsondata['StrapiId']);
        let resp = insertQuestion(isActive, questionType, difficulty, question, explanation, answerChoices, minimumTime, maximumTime, questionDifficultyValue, questionSubTypeValue, totalQuestionValue, correctAnswers, testType, diagnostic, type, subType, area, kahnAcademyType, isPublic, displayOrder, description, solvableUsingDesmos, strapiId);
        return resp;
    };
    return ((0, jsx_runtime_1.jsx)(Popover_1.default, Object.assign({ id: 'popover-review', open: open, anchorReference: 'anchorPosition', anchorPosition: { top: 100, left: 140 }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        }, hideBackdrop: true, sx: {
            '& .MuiPaper-root': {
                borderRadius: '3vh',
                border: '1px solid skyblue',
            },
        } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', sx: { width: '90vw', height: '80vh', p: 2 }, style: { borderRadius: '3vh' } }, { children: [(0, jsx_runtime_1.jsx)("input", { type: 'file', ref: fileInputRef, accept: '.xlsx,.xls', onChange: handleFileSelect, style: { display: 'none' }, id: 'file-upload' }), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: 'row', justifyContent: 'space-between', alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '1.5vmax', color: 'blue' } }, { children: (0, jsx_runtime_1.jsx)("b", { children: excelData.length > 0 ? 'Preview' : 'Import Questions' }) })) })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true }, { children: [!openModal ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Download file' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ style: { paddingRight: '2vh', color: 'blue' }, edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', onClick: saveAsExcelFile }, { children: (0, jsx_runtime_1.jsx)(FileDownload_1.default, {}) })) })) })), (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Upload file' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ style: { paddingRight: '2vh', color: 'blue' }, edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', onClick: handleUploadClick }, { children: (0, jsx_runtime_1.jsx)(FileUpload_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Close' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', onClick: handleClose, sx: { color: 'blue' } }, { children: (0, jsx_runtime_1.jsx)(HighlightOff_1.default, {}) })) }))] }))] })), !openModal ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [error != '' ? (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ color: 'red' }, { children: 'Please upload xls or xlsx file' })) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), excelData.length > 0 ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { marginTop: 2 } }, { children: (0, jsx_runtime_1.jsx)(TableContainer_1.default, Object.assign({ component: Paper_1.default, sx: { border: '1px solid #ccc', height: '66vh', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsxs)(Table_1.default, { children: [(0, jsx_runtime_1.jsx)(TableHead_1.default, { children: (0, jsx_runtime_1.jsx)(TableRow_1.default, { children: excelData[0].map((header, index) => ((0, jsx_runtime_1.jsx)(TableCell_1.default, Object.assign({ align: 'center', sx: { border: '1px solid #ccc' } }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ style: { fontSize: '1.5vh', fontWeight: 'bold', width: 'auto' } }, { children: header })) }), index))) }) }), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: excelData.slice(1).map((row, rowIndex) => ((0, jsx_runtime_1.jsx)(TableRow_1.default, { children: row.map((cell, cellIndex) => ((0, jsx_runtime_1.jsx)(TableCell_1.default, Object.assign({ align: 'left', sx: { border: '1px solid #ccc', whiteSpace: 'nowrap' } }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: md.render(cell.toString() || '') } }) }), cellIndex))) }, rowIndex))) })] }) })) })) })) : ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: gridStyle, onDrop: handleDrop, onDragOver: handleDragOver, onClick: handleUploadClick }, { children: [[...Array(66)].map((_, index) => ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: cellStyle }, index))), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: imageStyle }, { children: (0, jsx_runtime_1.jsx)(FileUpload_1.default, { sx: { width: '10vh', height: '10vh' } }) })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: messageStyle }, { children: 'Drag & drop a file here' }))] }))), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'flex', justifyContent: 'flex-end', paddingTop: '2vh' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', disabled: excelData.length > 0 ? false : true, variant: 'contained', sx: { borderRadius: 10, height: '4vh', width: '8vh', alignSelf: 'center' }, onClick: handleSaveClick }, { children: "Import" })) }))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '1.05vmax', fontWeight: 'bold', paddingTop: '2vh' } }, { children: status.length == 0 ? 'Completed Successfully' : 'Completed with some failures' })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, style: { height: '50vh', overflow: 'scroll' } }, { children: status &&
                                status.map((stat) => {
                                    return ((0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ id: 'modal-modal-description', sx: { mt: 2 } }, { children: stat })));
                                }) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ style: { display: 'flex', justifyContent: 'center', paddingTop: '2vh', height: '10vh' } }, { children: (0, jsx_runtime_1.jsx)(CustomnButton, Object.assign({ variant: 'contained', onClick: saveAsExcelFile }, { children: "Download Status File" })) }))] })), isProceesing ? ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ className: 'wait_stack_dashboard', justifyContent: 'center', alignItems: 'center', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(CircularProgress_1.default, { className: 'wait_icon' }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ style: { fontFamily: 'PoppinsMedium', fontSize: '1.5vmax', textAlign: 'center', color: 'black' } }, { children: " Please wait ..." }))] }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })) })));
};
exports.default = StrapiUpload;
